<template>
  <div style="clear: both;">
    <v-text-field :label="$t('Date_Initiated')" variant="underlined" :model-value="date" :readonly="readonly" density="comfortable"></v-text-field>
  </div>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    date: {
      type: String,
      default: new Date().toLocaleDateString()
    }
  }
}
</script>

<style>
.v-field {
  font-size: .95rem;
}

.v-label {
  font-size: .95rem;
}
.v-input__details {
  min-height: 14px;
  padding-top: 0px;
}
</style>
